var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSymptom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.167,
    height: 26.838,
    viewBox: "0 0 23.167 26.838",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symptom",
    transform: "translate(-697.153 -105.22)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_939",
    "data-name": "Line 939",
    x1: 4.337,
    transform: "translate(710.555 121.243)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_940",
    "data-name": "Line 940",
    x1: 4.337,
    transform: "translate(710.555 122.643)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2675",
    "data-name": "Path 2675",
    d: "M713.769,123.667a1.281,1.281,0,1,0,2.563,0,.177.177,0,0,0-.02-.1,1.576,1.576,0,0,0,1.4-1.557,1.6,1.6,0,0,0-1.419-1.577.7.7,0,0,0,.019-.2,1.281,1.281,0,0,0-2.563,0",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2676",
    "data-name": "Path 2676",
    d: "M714.143,117.97a3.556,3.556,0,0,1,1.7-.2,2.016,2.016,0,0,1,1.4.907,3.7,3.7,0,0,0,.335.611,3.907,3.907,0,0,0,.927.651,2.226,2.226,0,0,1,.926,1.537,2.144,2.144,0,0,1-.552,1.7,2.368,2.368,0,0,0,1.44-1.972,2.433,2.433,0,0,0-1.124-2.188,4.4,4.4,0,0,1-.828-.513,5.23,5.23,0,0,1-.474-.788,1.983,1.983,0,0,0-1.873-.769,4.2,4.2,0,0,0-1.873,1.025",
    fill: "#35b4cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2677",
    "data-name": "Path 2677",
    d: "M706.907,107.973a4.029,4.029,0,0,0,.375,2.307c.808,1.262,2.543,4.081,3,4.811a1.543,1.543,0,0,1,.256.709,1.1,1.1,0,0,1-.966,1.223c-1.459.394-1.695,1.242-1.577,1.833a4.385,4.385,0,0,1,.157,1.183,1,1,0,0,1-1.084.868,2.934,2.934,0,0,1-1.932-.927",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2678",
    "data-name": "Path 2678",
    d: "M706.987,105.923s2.563,3.174-5.856,3.352",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2679",
    "data-name": "Path 2679",
    d: "M705.408,112.015a2.513,2.513,0,0,1-1.715.611,2.4,2.4,0,0,1-1.656-.749",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2680",
    "data-name": "Path 2680",
    d: "M697.858,124.338a11.843,11.843,0,0,0,1.656,1.163,11.172,11.172,0,0,0,5.56,1.42h.039c2.405,0,2.445-1.144,2.287-1.775a2.232,2.232,0,0,1,.118-1.518,2.079,2.079,0,0,1,.2-.374.02.02,0,0,1,.02-.02.8.8,0,0,0-.69-1.242,4.262,4.262,0,0,1-2.426-.769",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2681",
    "data-name": "Path 2681",
    d: "M702.649,126.664a5.463,5.463,0,0,0-1.262,4.791",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2682",
    "data-name": "Path 2682",
    d: "M705.626,119a1.194,1.194,0,0,0-1.518-.414,1.033,1.033,0,0,0-.237,1.419,1.37,1.37,0,0,0-.355,2.445,1.939,1.939,0,0,1-1.537-.374,1.215,1.215,0,0,1-.3-1.479c.217-.355.65-.552.848-.907a5.965,5.965,0,0,0,.236-1.025,1.491,1.491,0,0,1,1.557-1.065A1.53,1.53,0,0,1,705.626,119Z",
    fill: "#ffc524"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymptom);
export default __webpack_public_path__ + "static/media/Symptom.f7eb42edd7cc3a01871454f7e397fc11.svg";
export { ForwardRef as ReactComponent };